import { DestroyRef, Injectable } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { ErrorService } from '@shared/services/error.service';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { ToastService } from 'src/app/shared/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class NewVersionCheckerService {
  private instanceId: string;

  constructor(
    private swUpdate: SwUpdate,
    private toastService: ToastService,
    private errorService: ErrorService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    if (this.swUpdate.isEnabled) {
      this.checkForUpdateEveryHour();
    }
  }

  checkForUpdateEveryHour(): void {
    this.subscriptionManager
      .createRequest(interval(1 * 60 * 60 * 1000).pipe(startWith(0)), 'everyOneHour$', this.instanceId)
      .subscribe({
        next: async () => {
          try {
            if (!this.subscriptionManager.getCancellationSubject(this.instanceId, this.instanceId)) {
              this.listenToUpdates();
            }

            if (this.subscriptionManager.getCancellationSubject(this.instanceId, this.instanceId)) {
              await this.swUpdate.checkForUpdate();
            }
          } catch (err) {
            console.error('Failed to check for updates:', err);
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  listenToUpdates(): void {
    this.subscriptionManager.createRequest(this.swUpdate.versionUpdates, 'versionUpdates', this.instanceId).subscribe({
      next: (event: VersionEvent) => {
        if (event.type === 'VERSION_READY') {
          this.toastService.displayNewUpdateAvailableToast();
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }
}
